import React from "react";
import { Input } from "../../../../shared/ui/controls/Input/Input";
import { FieldWrapper } from "../../../../shared/ui";
import { FilterBar } from "../../../../shared/ui/layouts/FilterBar";
import { useRescheduleFiltersParams, toRescheduleFiltersForm } from "../../../../features/reschedule";
import type { RescheduleFiltersForm } from "../../../../features/reschedule";
import { rescheduleColumns } from "../model/constants";
import Select from "../../../../shared/ui/controls/Select/Select";
import { RescheduleItemType, TimeEntryCategory } from "@myapp/contract";

const TYPE_OPTIONS = [
  { value: "", label: "Alle" },
  { value: "APPOINTMENT", label: "Termin" },
  { value: "TASK", label: "Aufgabe" },
  { value: "TIME_ENTRY", label: "Zeitmanagement" },
];

const REASON_OPTIONS = [
  { value: "", label: "Alle" },
  { value: "SICK_LEAVE", label: "Krankheit" },
  { value: "VACATION", label: "Urlaub" },
  { value: "TRAINING", label: "Schulung" },
  { value: "PERSONAL_LEAVE", label: "Privatzeit" },
];

export const RescheduleFilterBar: React.FC = () => {
  const [params, setParams] = useRescheduleFiltersParams();
  const filters = toRescheduleFiltersForm(params);

  const updateField = (field: keyof RescheduleFiltersForm, value: string) => {
    void setParams({ ...filters, [field]: value });
  };

  const handleSortChange = (
    field: RescheduleFiltersForm["sortField"],
    direction: RescheduleFiltersForm["sortDirection"],
  ) => {
    void setParams({ ...filters, sortField: field, sortDirection: direction });
  };

  return (
    <FilterBar columns={rescheduleColumns} gap={12} rowGap={8}>
      <FieldWrapper label="Typ" className="pl-[15px]">
        <Select
          options={TYPE_OPTIONS}
          value={filters.type}
          onChange={(value) =>
            void setParams({ ...filters, type: (value ?? "") as RescheduleItemType | "" })
          }
          placeholder="Alle"
        />
      </FieldWrapper>

      <FieldWrapper label="Titel">
        <Input
          as="input"
          value={filters.title}
          onChange={(value) => updateField("title", value)}
          placeholder=""
        />
      </FieldWrapper>

      <FieldWrapper
        label="Handwerker"
        sortKey="technicianName"
        activeSortField={filters.sortField}
        sortOrder={filters.sortDirection}
        onSortChange={(key, dir) =>
          handleSortChange(
            key as RescheduleFiltersForm["sortField"],
            dir as RescheduleFiltersForm["sortDirection"],
          )
        }
      >
        <Input
          as="input"
          value={filters.technicianName}
          onChange={(value) => updateField("technicianName", value)}
          placeholder=""
        />
      </FieldWrapper>

      <FieldWrapper
        label="Datum"
        sortKey="plannedStart"
        activeSortField={filters.sortField}
        sortOrder={filters.sortDirection}
        onSortChange={(key, dir) =>
          handleSortChange(
            key as RescheduleFiltersForm["sortField"],
            dir as RescheduleFiltersForm["sortDirection"],
          )
        }
      >
        <Input
          as="input"
          value={filters.dateFrom}
          onChange={(value) => updateField("dateFrom", value)}
          placeholder=""
          type="date"
        />
      </FieldWrapper>

      <FieldWrapper label="Grund" className="pr-[15px]">
        <Select
          options={REASON_OPTIONS}
          value={filters.reason}
          onChange={(value) =>
            void setParams({ ...filters, reason: (value ?? "") as TimeEntryCategory | "" })
          }
          placeholder="Alle"
        />
      </FieldWrapper>
    </FilterBar>
  );
};
